/**
 * Configuration for the app.
 */
const jobiqoAppConfig = require('../../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

// Set true for app localized.
const defaultLocale = 'en';
const locales = ['en'];

// The format map provides an ability to separate locales from the format of dates.
// An important note is that messages is the language that will be sent to the backend as the language to get data
// LocaleFormat is what will be configured in react-intl for number and date formats.
// The messages (texts in the website) will be based on messages information, so if the user visits in this case "en"
// he would see number formatted in "en" (but it could be configured for de or pt).
// Each of the keys in the mapping will be sent to nextJs as the allowed locale.
// const formatMap = {
//   [defaultLocale]: {
//     messages: defaultLocale,
//     localeFormat: defaultRegion,
//   },
// };
const formatMap = {};

module.exports = mergeDeepRight(jobiqoAppConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  public: {
    TURBOPACK_BUILD: true,
    LOCALES: locales,
    DEFAULT_LOCALE: defaultLocale,
    FORMAT_MAP: formatMap,
    SITENAME: 'HealthCareJobHunt',
    SITE_DESCRIPTION: 'Discover healthcare career opportunities at HealthCareJobHunt.com! Our job board connects employers with healthcare professionals, admin staff, and facility workers nationwide.',
    SHARING_BUTTONS_ENABLED: ['facebook', 'linkedin', 'email', 'twitter', 'whatsapp'],
    SUBSCRIPTIONS_FEATURE_ACTIVE: true,
    LINKEDIN_OAUTH_FEATURE_ACTIVE: true,
    GOOGLE_OAUTH_FEATURE_ACTIVE: true,
    NEWSLETTER_FEATURE_ACTIVE: true,
    GA4_MEASUREMENT_IDS: ['G-PE49LN39EM', 'G-WDTFZPTJFB'],
    SHOW_GA4_STATISTICS: false,
    PRICE_CONFIG: {
      CURRENCY_PLACEMENT: 'before',
      USE_SPACING: false,
    },
    ASSETS: {
      logo: '/static/healthcare/logo.png',
      loginImage: '/static/healthcare/login-banner.jpg',
      faviconsPath: '/static/healthcare',
    },
    OG_IMAGE: '/static/healthcare/og-image.jpg',
    THEME: {
      colors: {
        primary: '#03306d',
      },
    },
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      bounds: {
        swlat: 18.7763,
        swlng: 166.9999999,
        nelat: 74.071038,
        nelng: -66.885417,
      },
    },
    GOOGLE_MEASUREMENT_API_ENABLED: true,
    PRIVACY_LINK: 'https://www.healthcarejobhunt.com/privacy-policy',
    EURO_VAT_SYSTEM: false,
  },
});
